import React, { useState, useEffect } from 'react';
import '../../spinner.css';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
import { getUserDetails, storeUserDetails } from '../../services/UserService';
import { getUserProfile, updateProfile } from '../../services/ProfileService';
import { API_URL } from '../../utility/constants';
import { getAllCountryData, getAllStatesData, getAllCitiesData } from '../../services/CommonService';
import Loader from '../../utility/Loader';

export default function LearnerProfile() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [userProfile, setUserProfile] = useState({});
    const [file, setFile] = useState(null);
    const [imageSrc, setImageSrc] = useState("https://d2hskb47g5lnpk.cloudfront.net/user_profile_images/profile_image_default.avif");
    const [countriesList, setCountriesList] = useState([]);
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [countryCode, setCountryCode] = useState({});

    const [userDtl, setUserDtl] = useState({ cohort_desc: "" });

    useEffect(() => {
        const userDetails = getUserDetails();
        if (userDetails.token === undefined) {
            navigate('/login');
        } else {
            setUserDtl(userDetails.user);
            getCountries();
        }
    }, []);

    const getCountries = async () => {
        const userDetails = getUserDetails();
        if (userDetails.token !== undefined) {
            setLoading(true);
            const response = await getAllCountryData(userDetails.token);
            const countryList = response.data;
            setCountriesList(countryList);
            let cntry = [];
            let cntryCode = {};
            for (let i = 0; i < countryList.length; i++) {
                cntry.push({ label: countryList[i].country, value: countryList[i].country });

                cntryCode[countryList[i].country] = countryList[i].phone_cd
            }
            setCountries(cntry);
            setCountryCode(cntryCode);
            await getUserProfileData();
            setLoading(false);
        } else {
            toast.info("Please login again");
            navigate('/login');
        }
    };

    const getUserProfileData = async () => {
        const userDetails = getUserDetails();
        if (userDetails.token !== undefined) {
            const userProfileData = await getUserProfile(userDetails.token);
            if (userProfileData.error == false) {
                setUserProfile(userProfileData.data);
                const userDetails = getUserDetails();
                userDetails.user.first_name = userProfileData.data.first_name;
                userDetails.user.middle_name = userProfileData.data.middle_name;
                userDetails.user.last_name = userProfileData.data.last_name;
                userDetails.user.image_link = userProfileData.data.image_link;
                storeUserDetails(userDetails);
                //localStorage.setItem('userDetails', JSON.stringify(userDetails));
                if (userProfileData.data.image_link !== undefined && userProfileData.data.image_link !== null && userProfileData.data.image_link !== '') {
                    setImageSrc(userProfileData.data.image_link);
                }
                await changeCountryValue("country", userProfileData.data.country);
                await changeCountryValue("state", userProfileData.data.state);

            }
        } else {
            toast.info("Please login again");
            navigate('/login');
        }
    };

    const handleCountryValueChange = async (name, value) => {

        if (name === 'country') {
            setUserProfile({
                ...userProfile,
                ["state"]: "",
                [name]: value,
                ["city"]: ""
            });
        } else if (name === 'state') {
            setUserProfile({
                ...userProfile,
                [name]: value,
                ["city"]: ""
            });

        } else {
            setUserProfile({
                ...userProfile,
                [name]: value
            });
        }
        await changeCountryValue(name, value);
    };

    const changeCountryValue = async (name, value) => {
        const userDetails = getUserDetails();
        if (name === 'country') {
            let values = [];
            const st = await getAllStatesData(userDetails.token, value);

            for (let i = 0; i < st.data.length; i++) {
                values.push({ label: st.data[i].state, value: st.data[i].state });
            }
            setStates(values);
        }
        if (name === 'state') {
            let values = [];
            const st = await getAllCitiesData(userDetails.token, value);
            for (let i = 0; i < st.data.length; i++) {
                values.push({ label: st.data[i].city, value: st.data[i].city });
            }
            setCities(values);
        }
    };

    const handleValueChange = (e) => {
        const { name, value } = e.target;
        setUserProfile({
            ...userProfile,
            [name]: value,
        });
    };

    const validateUserProfile = () => {
        let returnValue = true;
        let message = "";
        if (userProfile.first_name !== undefined
            && userProfile.first_name !== null
            && userProfile.first_name !== '') {
            returnValue = returnValue && true;
        } else {
            message = "First Name is not valid";
            returnValue = returnValue && false;
        }
        if (userProfile.last_name !== undefined
            && userProfile.last_name !== null
            && userProfile.last_name !== '') {
            returnValue = returnValue && true;
        } else {
            message = "Last Name is not valid";
            returnValue = returnValue && false;
        }
        if (!returnValue) {
            toast.error(message);
        }
        return returnValue;
    };

    const handleProfileChange = async () => {
        const userDetails = getUserDetails();
        const isValid = validateUserProfile(userProfile);
        if (userProfile.phone_no && userProfile.phone_no.length > 10) {
            toast.warn("Phone number length is greater than 10 digits!");
        }
        else if (userProfile.zip_code && userProfile.zip_code.length > 5) {
            toast.warn("Zip Code length is greater than 5 digits!");
        }
        else if (isValid) {
            if (userDetails.token) {
                setLoading(true);

                let resp = await updateProfile(userProfile, userDetails.token);
                setLoading(false);
                if (resp.error === false) {
                    await getUserProfileData();
                    toast.success(resp.data);
                    window.location.reload();
                } else {
                    toast.error(resp.data);
                }
            } else {
                toast.info("Please login again");
                navigate('/login');
            }
        } else {

        }

    };

    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
        const selectFile = event.target.files[0];
        if (selectFile) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImageSrc(reader.result);
            };
            reader.readAsDataURL(selectFile);
        }
    };

    const handleUpload = async () => {
        const userDetails = getUserDetails();
        if (!file) {
            toast.error('Please select a file.');
            return;
        }

        const formData = new FormData();
        formData.append('file', file);

        try {
            setLoading(true);
            const response = await fetch(API_URL + 'users/profile/uploadProfileImage', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + userDetails.token
                },
                body: formData
            });
            setLoading(false);

            if (response.error) {
                toast.error('Failed to upload file');
            } else {
                const data = await response.json();
                await getUserProfileData();
                toast.success(data.data);
                window.location.reload();
            }
        } catch (error) {
            console.error('Error uploading file: ', error);
        }
    };

    const formatSixDigitNumber = (num) => {
        if (num === undefined) {
            return "";
        }
        let numStr = num.toString();
        while (numStr.length < 6) {
            numStr = '0' + numStr;
        }
        return numStr;
    };

    return (
        <div>
            {loading ? (
                <Loader />
            ) : (
                <div className='lg:py-10 lg:px-32 py-10 px-10'>
                    <h3 className='text-2xl text-secondary text-center inter-700 mb-6 md:mb-4 lg:mb-3 lg:hidden'>My Profile</h3>
                    <form>
                        <div className="profile-icon-wrap relative mx-auto lg:ml-0 w-32 h-32 rounded-full mb-5 md:mb-8">
                            <div className="profile-icon-box w-32 h-32 rounded-full overflow-hidden">
                                <img id="profile-image" className='max-w-full max-h-full' src={imageSrc} alt='profile' />
                            </div>
                            <label htmlFor="prfl-file-upload">
                                <img className='w-6 h-6' src='../images/pencil-icon.svg' alt='pencil' />
                            </label>
                            <input type="file" id="prfl-file-upload" aria-label='Upload Profile Icon' accept="image/*" onChange={handleFileChange} />
                        </div>
                        <div className='changpass-btn flex justify-center lg:justify-start mb-5 md:mb-8'>
                            <button onClick={() => handleUpload()} className='cursor-pointer bg-[#2D7B4B] hover:bg-black flex items-center justify-center px-10 h-10 2xl:h-16 text-white inter-700 text-base 2xl:text-2xl rounded-3xl lg:rounded-full transition duration-300 button-shadow' aria-label='Update Profile Picture'>Update Profile Picture</button>
                        </div>
                        <div className='flex justify-between flex-wrap'>
                            <div className='form-field w-full md:w-2/5 mb-5 md:mb-8'>
                                <label for="Country" className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>Country </label>
                                <Select id='Country' aria-label='Select Country' className='inter-400 bg-[#fbfbfb] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md'
                                    options={countries}
                                    value={countries.find(option => option.value === userProfile.country)}
                                    onChange={(values) => handleCountryValueChange("country", values.value)}
                                />
                                {/* <input type='text' name="country" value={userProfile.country} onChange={handleValueChange} placeholder='United State' className='inter-400 bg-[#EFEFEF] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required/> */}
                            </div>
                            {/* <div className='form-field w-full md:w-2/5 mb-5 md:mb-8'>
                                <label className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>Country Phone Code</label>
                                <input type='text' name="country_code" value={countryCode[userProfile.country]} onChange={handleValueChange} placeholder='' className='inter-800 bg-[#EFEFEF] text-black text-base border-5 border-[#B44D71] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required disabled/>
                            </div> */}
                        </div>
                        <div className='flex justify-between flex-wrap'>
                            <div className='form-field w-full md:w-1/4 mb-5 md:mb-8'>
                                <label for="First Name" className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>First Name <span className='text-[#f00]'>*</span></label>
                                <input id='First Name' type='text' name="first_name" value={userProfile.first_name} onChange={handleValueChange} placeholder='Enter Your First Name' className='inter-400 bg-[#fbfbfb] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required />
                            </div>
                            <div className='form-field w-full md:w-1/4 mb-5 md:mb-8'>
                                <label for="Middle Name" className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>Middle Name </label>
                                <input id='Middle Name' type='text' name="middle_name" value={userProfile.middle_name} onChange={handleValueChange} placeholder='Enter Your Middle Name' className='inter-400 bg-[#fbfbfb] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required />
                            </div>
                            <div className='form-field w-full md:w-1/4 mb-5 md:mb-8'>
                                <label for="Last Name" className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>Last Name <span className='text-[#f00]'>*</span></label>
                                <input id="Last Name" type='text' name="last_name" value={userProfile.last_name} onChange={handleValueChange} placeholder='Enter Your Last Name' className='inter-400 bg-[#fbfbfb] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required />
                            </div>
                        </div>
                        <div className='flex justify-between flex-wrap'>
                            <div className='form-field w-full md:w-1/4 mb-5 md:mb-8'>
                                <label for="Organization" className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>Organization</label>
                                <input id="Organization" type='text' name="customer_name" value={userProfile.customer_name} onChange={handleValueChange} placeholder='Enter Your Organization' className='inter-400 bg-[#fbfbfb] text-black text-base border-5 border-[#B44D71] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required disabled />
                            </div>
                            <div className='form-field w-full md:w-1/4 mb-5 md:mb-8'>
                                <label for="User ID" className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>User ID </label>
                                <input id="User ID" type='text' name="user_id" value={"UID" + formatSixDigitNumber(userProfile.user_id)} onChange={handleValueChange} placeholder='Enter Your Id' className='inter-400 bg-[#fbfbfb] text-black text-base border-5 border-[#B44D71] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required disabled />
                            </div>
                            <div className='form-field w-full md:w-1/4 mb-5 md:mb-8'>
                                <label for="Cohort" className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>Cohort </label>
                                <input id="Cohort" type='text' name="cohort_desc" value={userDtl.cohort_desc} onChange={handleValueChange} placeholder='Enter Your Cohort' className='inter-400 bg-[#fbfbfb] text-black text-base border-5 border-[#B44D71] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required disabled />
                            </div>
                        </div>
                        <div className='flex justify-between flex-wrap'>
                            {/* <div className='form-field w-full md:w-2/5 mb-5 md:mb-8'>
                                <label className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>Phone </label>
                                <div className='relative'>
                                    <input type='number' name="phone_no" value={userProfile.phone_no} onChange={handleValueChange} placeholder='' className='inter-400 bg-[#fbfbfb] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 pr-6 pl-16  2xl:pr-10 transition duration-300' required/>
                                    <div className='absolute left-0 top-0 w-14'>
                                        <input type='text' name="country_code" value={countryCode[userProfile.country]} onChange={handleValueChange} placeholder='' className='inter-400 bg-transparent text-black text-base border-r border-[#bbb] focus:border-[#B44D71] text-center h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-2 transition duration-300 inline-block' required disabled/>
                                    </div>
                                </div>  
                            </div> */}
                            {/* <div className='form-field w-full md:w-2/5 mb-5 md:mb-8'>
                                <label className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>Address 01 <span className='text-[#f00]'>*</span></label>
                                <input type='text' name="addr_line1" value={userProfile.addr_line1} onChange={handleValueChange} placeholder='' className='inter-400 bg-[#fbfbfb] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required/>
                            </div> */}
                        </div>
                        <div className='flex justify-between flex-wrap'>
                            {/* <div className='form-field w-full md:w-2/5 mb-5 md:mb-8'>
                                <label className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>Address 02 </label>
                                <input type='text' name="addr_line2" value={userProfile.addr_line2} onChange={handleValueChange} placeholder='' className='inter-400 bg-[#fbfbfb] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required/>
                            </div> */}
                            <div className='form-field w-full md:w-2/5 mb-5 md:mb-8'>
                                <label for="State" className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>State </label>
                                <Select id='State' aria-label='Select State' className='inter-400 bg-[#fbfbfb] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md'
                                    options={states}
                                    value={states.find(option => option.value === userProfile.state)}
                                    onChange={(values) => handleCountryValueChange("state", values.value)}
                                />
                                {/* <input type='text' name="state" value={userProfile.state} onChange={handleValueChange} placeholder='' className='inter-400 bg-[#EFEFEF] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required/> */}
                            </div>
                            <div className='form-field w-full md:w-2/5 mb-5 md:mb-8'>
                                <label for="City" className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>City</label>
                                <Select id='City' aria-label='Select State' className='inter-400 bg-[#fbfbfb] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md'
                                    options={cities}
                                    value={cities.find(option => option.value === userProfile.city)}
                                    onChange={(values) => handleCountryValueChange("city", values.value)}
                                />
                                {/* <input type='text' name="city" value={userProfile.city} onChange={handleValueChange} placeholder='' className='inter-400 bg-[#EFEFEF] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required/> */}
                            </div>
                        </div>
                        <div className='flex justify-between flex-wrap'>
                            <div className='form-field w-full md:w-2/5 mb-5 md:mb-8'>
                                <label for="zip Code" className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>Zip Code </label>
                                <input id="zip Code" type='number' name="zip_code" value={userProfile.zip_code} onChange={handleValueChange} placeholder='Zip Code' className='inter-400 bg-[#fbfbfb] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required />
                            </div>
                        </div>
                        {/* <div className='flex justify-between flex-wrap'>
                            <div className='form-field w-full md:w-2/5 mb-5 md:mb-8'>
                                <label className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>Zip Code <span className='text-[#f00]'>*</span></label>
                                <input type='number' name="zip" placeholder='' className='inter-400 bg-[#EFEFEF] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required/>
                            </div>
                        </div> */}
                        <div className='flex justify-between flex-wrap'>
                            <div className='w-full md:w-2/5 mb-5 md:mb-8'>
                                <button type="button" onClick={() => handleProfileChange()} className='w-full md:w-auto  bg-primary hover:bg-black flex items-center justify-center px-10 h-10 2xl:h-16 text-white inter-700 text-base 2xl:text-2xl rounded-3xl lg:rounded-full transition duration-300 button-shadow' aria-label='Update Profile'>Update Profile</button>
                            </div>
                            <div className='w-full md:w-2/5 mb-5 md:mb-8'>
                                <button type="button" onClick={() => navigate('/learner/passwordreset')} className='w-full md:w-auto  bg-secondary hover:bg-black flex items-center justify-center px-10 h-10 2xl:h-16 text-white inter-700 text-base 2xl:text-2xl rounded-3xl lg:rounded-full transition duration-300 button-shadow' aria-label='Change Password'>Change Password</button>
                            </div>
                        </div>
                    </form>
                </div>
            )
            }
        </div>
    );
}